import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { ORGANISATIONSHIPPINGLINESELECTIONS_CREATE_MUTATION, 
  ORGANISATIONSHIPPINGLINESELECTIONS_DELETE_MUTATION, ORGANISATIONSHIPPINGLINESELECTIONS_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
const store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: ORGANISATIONSHIPPINGLINESELECTIONS_QUERY,
    fetchAllFieldName: 'organisationShippingLineSelections',

    createMutation:  ORGANISATIONSHIPPINGLINESELECTIONS_CREATE_MUTATION,
    createMutationName: 'createOrganisationShippingLineSelection',
    createFieldName: 'organisationshippinglineselection',

    deleteMutation: ORGANISATIONSHIPPINGLINESELECTIONS_DELETE_MUTATION,
    deleteMutationName: 'deleteOrganisationShippingLineSelection',
    deleteFieldName: 'organisationshippinglineselection',
  },
  getters: {
    shippingLineIds(state, getters, rootState) {
      return state.entries.map(item => item.shippingLine.id);
    }
  }
})
/* eslint-enable no-unused-vars */

export default store

